import { setupListeners } from '@reduxjs/toolkit/query'
import { Tuple, configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import { middleware as accountsApiMiddleware } from '@/apis/accounts/slice'
import { middleware as appsApiMiddleware } from '@/apis/apps/slice'
import { middleware as billingApiMiddleware } from '@/apis/billing/slice'
import { middleware as emailiniumApiMiddleware } from '@/apis/emailinium/slice'
import { isProd } from '@/utils'
import rootReducer from './reducers'
import rootSaga from './sagas'

const configureAppStore = (preloadedState = {}) => {
  const sagaMiddleware = createSagaMiddleware()

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        new Tuple(
          sagaMiddleware,
          accountsApiMiddleware,
          appsApiMiddleware,
          billingApiMiddleware,
          emailiniumApiMiddleware
        )
      ),
    preloadedState,
  })

  sagaMiddleware.run(rootSaga)

  if (!isProd && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer))
  }

  return store
}

export const store = configureAppStore()

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
